<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <table class="hiaTable">
      <thead>
        <tr>
          <th>Indicator</th>
          <th style="width: 30%">Description</th>
          <th>Total Records</th>
          <th>No Rec</th>
          <th>Additions</th>
          <th>Deletions</th>
          <th>Accuracy Rate</th>
        </tr>
      </thead>
      <tr v-for="(row, i) in tableData" :key="i">
        <td class="textAlignLeft">{{row.shortDescription}}</td>
        <td class="textAlignLeft">{{row.longDescription}}</td>
        <td>{{row.noRec + row.additions + row.deletions}}</td>
        <td>{{row.noRec}}</td>
        <td>{{row.additions}}</td>
        <td>{{row.deletions}}</td>
        <td>{{formatPercentage(row.accuracy)}}</td>
      </tr>
      <tr class="strong emphasis" v-if="tableData.length > 0">
        <td class="textAlignLeft">Totals</td>
        <td></td>
        <td>{{summary[3] + summary[4] + summary[5]}}</td>
        <td>{{summary[3]}}</td>
        <td>{{summary[4]}}</td>
        <td>{{summary[5]}}</td>
        <td>{{summary[6]}}</td>
      </tr>
      <tr v-if="tableData.length === 0">
        <td colspan="7" class="textAlignLeft">{{loading ? 'loading...' : 'No PSI Data Found'}}</td>
      </tr>
    </table>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from '@/utilities/axios-global'
  import hiaFilters from '@/mixins/hiaFilters'
  import money from '@/mixins/money'
  import dashboardHelper from '@/mixins/dashboardHelper'
  import dateHelper from '@/mixins/date-helper'

  export default {
    name: 'IP_PsiSummaryPrintable',
    mixins: [hiaFilters, money, dashboardHelper, dateHelper],
    props: ['drgTableIds'],
    components: {},
    data: function () {
      return {
        tableData: [],
        filterCriteria: '',
        loading: false,
        dialogVisible: false,
        summaryDialogVisible: false,
        subDrgTableIds: null,
        summaryRow: {}
      }
    },
    methods: {
      async getData() {
        const payload = {
          drgTableIds: this.drgTableIds,
          includeAccts: true,
          statType: 'test'
        }
        try {
          this.loading = true
          const response = await axios.post(this.baseApiUrl + '/reports/dashboard/ipPsiSummary', payload)
          this.tableData = response.data
        } catch (err) {
          this.tableData = []
        } finally {
          this.loading = false
        }
      },
      showSummary(row) {
        this.summaryRow = row
        this.summaryDialogVisible = !this.summaryDialogVisible
      },
      getSummaries() {
        const param = {
          columns: [
            { property: 'shortDescription' },
            { property: 'longDescription' },
            { property: '' },
            { property: 'noRec' },
            { property: 'additions' },
            { property: 'deletions' },
            { property: 'accuracy' }
          ],
          data: this.tableData
        }
        return this.getSummary(param)
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl']),
      summary: function () {
        const param = {
          columns: [
            { property: 'shortDescription' },
            { property: 'longDescription' },
            { property: '' },
            { property: 'noRec' },
            { property: 'additions' },
            { property: 'deletions' },
            { property: 'accuracy' }
          ],
          data: this.tableData
        }
        return this.getSummary(param)
      }
    },
    mounted: async function () {
      await this.getData()
    },
    watch: {
      drgTableIds: async function () {
        await this.getData()
      }
    }
  }
</script>

<style scoped>
.hiaTable thead th {
  text-align: center;
}

.hiaTable tr td {
  text-align: right;
}
</style>
